/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The SmsTemplatesSmsTemplate model module.
 * @module model/SmsTemplatesSmsTemplate
 * @version v0.3
 */
export default class SmsTemplatesSmsTemplate {
  /**
   * Constructs a new <code>SmsTemplatesSmsTemplate</code>.
   * @alias module:model/SmsTemplatesSmsTemplate
   * @class
   * @param name {String} Name of the SMS template
   * @param body {String} Body text of the SMS template
   */
  constructor(name, body) {
    this.name = name;
    this.body = body;
  }

  /**
   * Constructs a <code>SmsTemplatesSmsTemplate</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/SmsTemplatesSmsTemplate} obj Optional instance to populate.
   * @return {module:model/SmsTemplatesSmsTemplate} The populated <code>SmsTemplatesSmsTemplate</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new SmsTemplatesSmsTemplate();
      if (data.hasOwnProperty('name'))
        obj.name = ApiClient.convertToType(data['name'], 'String');
      if (data.hasOwnProperty('body'))
        obj.body = ApiClient.convertToType(data['body'], 'String');
    }
    return obj;
  }
}

/**
 * Name of the SMS template
 * @member {String} name
 */
SmsTemplatesSmsTemplate.prototype.name = undefined;

/**
 * Body text of the SMS template
 * @member {String} body
 */
SmsTemplatesSmsTemplate.prototype.body = undefined;

